import onboarding from 'assets/images/onboarding.png'
import RouteConst from 'constants/RouteConst'
import SessionConst from 'constants/SessionConst'
import React, { Component } from 'react'
import {
  isArrayNotEmpty,
  isObjectEmpty,
  removeHotelInfoFromSession,
  removeLockStatusFromSession,
} from 'utilities/JSUtil'
import { getSessionItem } from '../../utilities/SessionHelper'
import Table from '../molecules/Table/Table'
import './Account.scss'

/**
 * Displays the account details for the user
 */
class Account extends Component {
  /**
   * Removes any hotel related session data, retrieves the current user from
   * session and builds the data required for rendering
   * @param {Object} props the component's properties
   */
  constructor(props) {
    super(props)
    removeHotelInfoFromSession()
    removeLockStatusFromSession()
    let user = getSessionItem(SessionConst.USER)

    if (!user || isObjectEmpty(user)) {
      this.props.history.push(RouteConst.ROUTE_HOME_PAGE)
    }

    let accountDetails = [
      ['First Name', user.firstName],
      ['Last Name', user.lastName],
      ['Login Username', user.username],
      [
        'Roles',
        this.getuserDisplayRole(
          user.jobRoles,
          user.propelRoles,
          user.hrpmRoles
        ),
      ],
      ['Hotel List', user.propertyList?.join(', ')],
    ]

    this.state = {
      hotelCode: '',
      accountDetails: accountDetails,
      errorMessage: null,
      loading: false,
      user: user,
    }
  }

  getuserDisplayRole = (roles, propelRoles, hrpmRoles) => {
    let displayRoles = []
    if (isArrayNotEmpty(roles)) {
      displayRoles.push(roles.join(', '))
    }
    if (isArrayNotEmpty(propelRoles)) {
      displayRoles.push(propelRoles.join(', '))
    }
    if (isArrayNotEmpty(hrpmRoles)) {
      displayRoles.push(hrpmRoles.join(', '))
    }

    if (isArrayNotEmpty(displayRoles)) {
      return displayRoles.join(', ')
    }
  }

  render() {
    return (
      <div className='account-page'>
        <img src={onboarding} className='account-page-onboarding-img' />
        <div className='account-details'>
          <h4 className='welcome-message'>Account Details</h4>
          <Table
            bordered
            striped
            data={this.state.accountDetails}
            className='accounts-table'
          />
        </div>
      </div>
    )
  }
}

export default Account
